/**
 * @ngInject
 */

function championKerningFix ($timeout) {

	function link (scope, elem, attrs) {
		var styles = getComputedStyle(elem[0]);
		if (styles.fontFamily.toLowerCase().indexOf('champion') != -1 && styles.fontFamily.toLowerCase().indexOf('heavy') != -1) {
			if (elem[0].textContent.toUpperCase().indexOf('VÆ') != -1) {
				elem[0].innerHTML = elem[0].innerHTML.split('VÆ').join('<span class="fix-kerning">V</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('væ').join('<span class="fix-kerning">v</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('Væ').join('<span class="fix-kerning">V</span>Æ');
			}
			if (elem[0].textContent.toUpperCase().indexOf('TÆ') != -1) {
				elem[0].innerHTML = elem[0].innerHTML.split('TÆ').join('<span class="fix-kerning">T</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('tæ').join('<span class="fix-kerning">t</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('Tæ').join('<span class="fix-kerning">T</span>Æ');
			}
		}
	}

	return {
		restrict : 'A',
		link : link
	}
}